import { useTranslations } from '@npco/common-utils-translations'
import { Box, COLOR, Flex, Tutorial } from '@npco/zeller-design-system'
import { ScrollableContentWithNewBadge } from 'features/StartupModals/common/components/ScrollableContentWithNewBadge/ScrollableContentWithNewBadge'
import { corporateCardStartupTranslations } from 'features/StartupModals/CorporateCardStartup/CorporateCardStartup.i18n'
import {
  Subtitle,
  Title,
} from 'features/StartupModals/SetupFlow/SetupFlowModal/SetupFlowModal.styled'

export const CorporateCardStartupModalMainContent = () => {
  const t = useTranslations(corporateCardStartupTranslations)
  return (
    <ScrollableContentWithNewBadge>
      <Title>{t('title')}</Title>
      <Subtitle>{t('description')}</Subtitle>

      <Flex flexDirection="column" gap="4px" lineHeight="24px">
        <Tutorial.BulletPoint
          iconColour={COLOR.GREEN_1000}
          text={t('point1')}
        />
        <Tutorial.BulletPoint
          iconColour={COLOR.GREEN_1000}
          text={t('point2')}
        />
        <Tutorial.BulletPoint
          iconColour={COLOR.GREEN_1000}
          text={t('point3')}
        />
        <Tutorial.BulletPoint
          iconColour={COLOR.GREEN_1000}
          text={t('point4')}
        />
        <Box mt="24px">
          <Subtitle>{t('description2')}</Subtitle>
        </Box>
      </Flex>
    </ScrollableContentWithNewBadge>
  )
}
